export default {
    getCampuses: { method: 'get', url: 'companies/campuses' },
    postCampuses: { method: 'post', url: 'companies/campuses' },
    updateCampuses: { method: 'put', url: 'companies/campuses/{id}' },
    deleteCampuses: { method: 'delete', url: 'companies/campuses/{id}' },
    getCampusesGerenciaisWithOferta: { method: 'get', url: 'companies/campuses/gerenciais-with-oferta' },
}